import IconAppealingActive from '../assets/IconAppealingActive.svg'
import IconAppealingInactive from '../assets/IconAppealingInactive.svg'
import IconFlagActive from '../assets/IconFlagActive.svg'
import IconFlagInactive from '../assets/IconFlagInactive.svg'
import IconFolderActive from '../assets/IconFolderActive.svg'
import IconFolderInactive from '../assets/IconFolderInactive.svg'
import IconUserActive from '../assets/IconUserActive.svg'
import IconUserInactive from '../assets/IconUserInactive.svg'
import IconVotingActive from '../assets/IconVotingActive.svg'
import IconVotingInactive from '../assets/IconVotingInactive.svg'
import IconRulingActive from '../assets/IconRulingActive.svg'
import IconRulingInactive from '../assets/IconRulingInactive.svg'
import IconRewardsActive from '../assets/IconRewardsActive.svg'
import IconRewardsInactive from '../assets/IconRewardsInactive.svg'

export { default as IconShield } from '../assets/IconShieldCheck.svg'

export const IconAppealing = {
  active: IconAppealingActive,
  inactive: IconAppealingInactive,
}

export const IconFlag = {
  active: IconFlagActive,
  inactive: IconFlagInactive,
}

export const IconFolder = {
  active: IconFolderActive,
  inactive: IconFolderInactive,
}

export const IconRewards = {
  active: IconRewardsActive,
  inactive: IconRewardsInactive,
}

export const IconRuling = {
  active: IconRulingActive,
  inactive: IconRulingInactive,
}

export const IconUser = {
  active: IconUserActive,
  inactive: IconUserInactive,
}

export const IconVoting = {
  active: IconVotingActive,
  inactive: IconVotingInactive,
}
